import React from "react";
import { clientData } from "../../data/clientData";

function Client() {
  return (
    <section className="bg-bg-black bg-cover w-full md:py-[100px] py-[78px]">
      <div className="container mx-auto">
        <h2 className="md:text-5xl text-[28px] font-bold md:pr-8 pr-5 text-center text-white">Our Clients</h2>
      <div className=" flex flex-nowrap overflow-x-auto flex-col items-center md:flex-row md:flex-nowrap md:justify-between gap-6 mt-[64px]">
        {clientData.map(({id, image}) => (
          <div
            key={id}
            className="bg-[#212121] py-[18px] px-[22px] md:py-[20px] md:px-[50px]"
          >
            <img
              src={image}
              className="h-[150px] w-[282px] clientImg"
              alt="Client's Logo"
            />
          </div>
        ))}
      </div>
      </div>
    </section>
  );
}

export default Client;
